import { Card, CardTitle, Container } from "react-bootstrap";
import { Link } from "react-router-dom";
import { bigDealDays2026Cover, bigDealDaysLive2026Cover, portStrikeCover, primeDayOverCover, primeDealDaysCover, primeStartsNowCover } from "../covers";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { responsiveCarousel } from "../responsive";


export default function NewsCarousel() {
return (
    <Container>
    <Carousel 
additionalTransfrom={0}
arrows
centerMode={false}
className=""
containerClass="container-with-dots"
dotListClass=""
draggable
focusOnSelect={false}
itemClass=""
keyBoardControl
minimumTouchDrag={80}
pauseOnHover
renderArrowsWhenDisabled={false}
renderButtonGroupOutside={false}
autoPlay={false}
responsive={responsiveCarousel}
rewind={true}
rewindWithAnimation={false}
showDots={false}
sliderClass=""
slidesToSlide={1}
swipeable
>
<Card className="homeCard">
                    <Link to="/primeBigDealDaysLive2026" className="cardLink">
                        <div>
                            <img className="homeCardImage" src={ bigDealDaysLive2026Cover.src } alt={ bigDealDaysLive2026Cover.alt }/>
                            <Container className="homeCardBody">
                                <CardTitle>Prime Big Deal Days 2026 Is Live</CardTitle>
                                <span className="homePostPublish">Published on October 6th, 2026</span>
                            </Container>
                        </div>
                    </Link>
            </Card>

<Card className="homeCard">
                    <Link to="/primeBigDealDays2026" className="cardLink">
                        <div>
                            <img className="homeCardImage" src={ bigDealDays2026Cover.src } alt={ bigDealDays2026Cover.alt }/>
                            <Container className="homeCardBody">
                                <CardTitle>Prime Big Deal Days 2026 Starts Tomorrow: What to Know</CardTitle>
                                <span className="homePostPublish">Published on October 5th, 2026</span>
                            </Container>
                        </div>
                    </Link>
            </Card>

<Card className="homeCard">
                    <Link to="/primeDayOver" className="cardLink">
                        <div>
                            <img className="homeCardImage" src={ primeDayOverCover.src } alt={ primeDayOverCover.alt }/>
                            <Container className="homeCardBody">
                                <CardTitle>Amazon Prime Deals Day is Over...</CardTitle>
                                <span className="homePostPublish">Published on October 11th, 2024</span>
                            </Container>
                        </div>
                    </Link>
            </Card>

            <Card className="homeCard">
                    <Link to="/primeStartsNow" className="cardLink">
                        <div>
                            <img className="homeCardImage" src={ primeStartsNowCover.src } alt={ primeStartsNowCover.alt }/>
                            <Container className="homeCardBody">
                                <CardTitle>BREAKING: Amazon Prime Deals Day is Here!</CardTitle>
                                <span className="homePostPublish">Published on October 8th, 2024</span>
                            </Container>
                        </div>
                    </Link>
            </Card>

        <Card className="homeCard">
                    <Link to="/primeDealDays" className="cardLink">
                        <div>
                            <img className="homeCardImage" src={ primeDealDaysCover.src } alt={ primeDealDaysCover.alt }/>
                            <Container className="homeCardBody">
                                <CardTitle>Amazon Prime Big Deals Day: Get Ready for 48 Hours of Epic Saving</CardTitle>
                                <span className="homePostPublish">Published on October 6th, 2024</span>
                            </Container>
                        </div>
                    </Link>
            </Card>

<Card className="homeCard">
                <Link to="/blog" className="cardLink">
                    <div>
                        <img className="homeCardImage" src={ portStrikeCover.src } alt={ portStrikeCover.alt }/>
                        <Container className="homeCardBody">
                            <CardTitle>Port Strikes: How Labor Disputes Could Disrupt Your Amazon Deliveries</CardTitle>
                            <span className="homePostPublish">Published on October 3rd, 2024</span>
                        </Container>
                    </div>
                </Link>
        </Card>
</Carousel>
    </Container>

)
}